"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContent = void 0;
const react_1 = __importStar(require("react"));
const DSTL001_1 = require("../DST/DSTL001");
const academy_1 = require("./academy");
const banner_1 = require("./banner");
const company_1 = require("./company");
const klass_1 = require("./klass");
const statistics_1 = require("./statistics");
const AdminTitle_1 = require("./ui/AdminTitle");
const AssignmentTitle_1 = require("../DST/DSTL001/component/DSTL001_List_Child/AssignmentTitle");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const ConcurrentStatistics_1 = require("./statistics/ConcurrentStatistics");
const ConcurrentStatisticsTitle_1 = require("./statistics/ConcurrentStatisticsTitle");
exports.AdminContent = react_1.default.memo(({ menu, menuDetail, showDepth, props, handlerPreviousMenu }) => {
    const historyStore = (0, GlobalStateProvider_1.useHistoryStore)();
    const [searchOption, setSearchOption] = react_1.default.useState();
    const [backOfficeSearchOption, setBackOfficeSearchOption] = react_1.default.useState({ keyword: '', status: 'select', type: 'select' });
    const [userType, setUserType] = react_1.default.useState('00');
    const [refreshRate, setRefreshRate] = react_1.default.useState(0);
    const [page, setPage] = react_1.default.useState(0);
    const prevMenuRef = react_1.default.useRef(menu);
    const prevMenuDetailRef = react_1.default.useRef(menuDetail);
    const isMenuChange = prevMenuRef.current !== menu || prevMenuDetailRef.current !== menuDetail;
    if (isMenuChange) {
        prevMenuRef.current = menu;
        prevMenuDetailRef.current = menuDetail;
    }
    const effectivePage = isMenuChange ? 0 : page;
    const concurrentStatisticsRef = react_1.default.useRef(null);
    (0, react_1.useEffect)(() => {
        setPage(0);
        setSearchOption('');
        setUserType('00');
        historyStore.clearHistoryForPage("testListPage");
        historyStore.clearHistoryForPage("assignmentListPage");
    }, [menu, menuDetail]);
    (0, react_1.useEffect)(() => {
        const isTest = menuDetail === 'test' ? true : false;
        const previousPage = historyStore.getRecentPageHistory(isTest ? 'testListPage' : 'assignmentListPage');
        const searchOptions = previousPage?.searchOption;
        if (searchOptions === undefined) {
            setBackOfficeSearchOption({ keyword: '', status: 'select', type: 'select' });
            return;
        }
        ;
        setBackOfficeSearchOption(searchOptions);
    }, [historyStore, menuDetail, showDepth]);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('UPDATE_PAGE', setPage);
        return () => {
            APP.eventManager.unsubscribe('UPDATE_PAGE', setPage);
        };
    }, []);
    const handlerUpdateSearch = (option) => {
        setSearchOption(option);
        setPage(0);
    };
    const refresh = () => {
        concurrentStatisticsRef.current?.refresh();
    };
    const renderMainContent = (0, react_1.useMemo)(() => {
        switch (menu) {
            case 'serviceManagment':
                if (menuDetail === 'company') {
                    switch (showDepth) {
                        case 'list':
                            return react_1.default.createElement(company_1.CompanyList, { initPage: effectivePage, searchOption: searchOption });
                        case 'regist':
                            return react_1.default.createElement(company_1.CompanyItem, { isModify: true });
                        case 'modify':
                            return react_1.default.createElement(company_1.CompanyItem, { ...props, isModify: true });
                        case 'detail':
                            return react_1.default.createElement(company_1.CompanyItem, { ...props, isModify: false });
                    }
                }
            case 'classManagement':
                if (menuDetail === 'classManagement') {
                    switch (showDepth) {
                        case 'list':
                            return react_1.default.createElement(klass_1.KlassList, { initPage: effectivePage, searchOption: searchOption });
                        case 'regist':
                            return react_1.default.createElement(klass_1.KlassItem, { isModify: true });
                        case 'modify':
                            return react_1.default.createElement(klass_1.KlassItem, { ...props, isModify: true });
                        case 'detail':
                            return react_1.default.createElement(klass_1.KlassItem, { ...props, isModify: false });
                    }
                }
                if (menuDetail === 'banner') {
                    switch (showDepth) {
                        case 'list':
                            return react_1.default.createElement(banner_1.BannerList, { initPage: effectivePage, searchOption: searchOption });
                        case 'regist':
                            return react_1.default.createElement(banner_1.BannerItem, { ...props, isNew: true });
                        case 'modify':
                            return react_1.default.createElement(banner_1.BannerItem, { ...props, isNew: false });
                    }
                }
            case 'academyManagement':
                if (menuDetail === 'academyManagement') {
                    switch (showDepth) {
                        case 'list':
                            return react_1.default.createElement(academy_1.AcademyList, { initPage: effectivePage, searchOption: searchOption });
                        case 'regist':
                            return react_1.default.createElement(academy_1.AcademyItem, { isModify: true });
                        case 'detail':
                            return react_1.default.createElement(academy_1.AcademyItem, { ...props, isModify: false });
                    }
                }
                if (menuDetail === 'academyClassManagement') {
                    switch (showDepth) {
                        case 'list':
                            return react_1.default.createElement(klass_1.KlassList, { initPage: effectivePage, searchOption: searchOption, hideMembersColumn: true });
                        case 'detail':
                            return react_1.default.createElement(academy_1.AcademyClassItem, { ...props });
                    }
                }
            case 'academyStatistics':
                if (menuDetail === 'academyStatistics') {
                    switch (showDepth) {
                        case 'list':
                            return react_1.default.createElement(academy_1.AcademyStatisticsList, { initPage: effectivePage, searchOption: searchOption });
                        case 'detail':
                            return react_1.default.createElement(academy_1.AcademyStatisticsItem, { ...props });
                    }
                }
                if (menuDetail === 'academyClassStatistics') {
                    switch (showDepth) {
                        case 'list':
                            return react_1.default.createElement(klass_1.KlassList, { initPage: effectivePage, searchOption: searchOption, hideMembersColumn: true });
                        case 'detail':
                            return react_1.default.createElement(academy_1.AcademyClassItem, { ...props });
                    }
                }
            case 'backOffice':
                const isTest = menuDetail === 'test' ? true : false;
                switch (showDepth) {
                    case 'list':
                        return (react_1.default.createElement("div", { className: "dst" },
                            react_1.default.createElement(DSTL001_1.DSTL001_List, { isTeacher: true, isTest: isTest, isBackOffice: true })));
                    case 'detail':
                        return (react_1.default.createElement("div", { className: "dst" },
                            react_1.default.createElement(DSTL001_1.DSTL001_Detail, { isTest: isTest, ...props })));
                    case 'regist':
                        return (react_1.default.createElement("div", { className: "dst" },
                            react_1.default.createElement(DSTL001_1.DSTP001_Regist, { isBackOffice: true, isTest: isTest, isTeacher: true, isModify: false })));
                    case 'modify':
                        return (react_1.default.createElement("div", { className: "dst" },
                            react_1.default.createElement(DSTL001_1.DSTP001_Regist, { isBackOffice: true, isTest: isTest, isTeacher: true, isModify: true, ...props })));
                }
            case 'statistics':
                if (menuDetail === 'userStatistics') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(statistics_1.StatisticsList, { initPage: effectivePage, searchOption: searchOption, userType: userType }));
                        case 'detail':
                            return react_1.default.createElement(statistics_1.StatisticsItem, { ...props });
                    }
                }
                else if (menuDetail === 'concurrentStatistics') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(ConcurrentStatistics_1.ConcurrentStatistics, { ref: concurrentStatisticsRef, refreshRate: refreshRate }));
                    }
                }
            default:
                return null;
        }
    }, [menu, menuDetail, showDepth, page, searchOption, userType, refreshRate, refresh]);
    const renderTitleProps = (0, react_1.useMemo)(() => {
        switch (menu) {
            case 'serviceManagment':
                if (menuDetail === 'company') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(company_1.CompanyListTitle, { searchOption: searchOption, setSearchOption: handlerUpdateSearch }));
                    }
                }
                if (menuDetail === 'user')
                    return '관리자 목록';
            case 'classManagement':
                if (menuDetail === 'classManagement') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(klass_1.KlassListTitle, { searchOption: searchOption, setSearchOption: handlerUpdateSearch }));
                    }
                }
                if (menuDetail === 'banner') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(banner_1.BannerListTitle, { searchOption: searchOption, setSearchOption: handlerUpdateSearch }));
                    }
                }
            case 'academyManagement':
                if (menuDetail === 'academyManagement') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(academy_1.AcademyListTitle, { searchOption: searchOption, setSearchOption: handlerUpdateSearch }));
                    }
                }
                if (menuDetail === 'academyClassManagement') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(academy_1.AcademyClassListTitle, { searchOption: searchOption, setSearchOption: handlerUpdateSearch }));
                    }
                }
            case 'academyStatistics':
                if (menuDetail === 'academyStatistics') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(academy_1.AcademyStatisticsListTitle, { searchOption: searchOption, setSearchOption: handlerUpdateSearch }));
                    }
                }
                if (menuDetail === 'academyClassStatistics') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(academy_1.AcademyClassListTitle, { searchOption: searchOption, setSearchOption: handlerUpdateSearch }));
                    }
                }
            case 'backOffice':
                switch (showDepth) {
                    case 'list':
                        const isTest = menuDetail === 'test' ? true : false;
                        return (react_1.default.createElement(AssignmentTitle_1.AssignmentTitle, { isHideSelectDelBtn: true, isBackOffice: true, isTest: isTest, isTeacher: true, status: backOfficeSearchOption?.status || 'select', type: backOfficeSearchOption?.type || 'select', keyword: backOfficeSearchOption?.keyword || '', setStatus: (status) => {
                                APP.eventManager.publish('UPDATE_SEARCH_OPTION', {
                                    status,
                                });
                                setBackOfficeSearchOption(prev => ({
                                    ...prev,
                                    status,
                                }));
                            }, setType: (type) => {
                                APP.eventManager.publish('UPDATE_SEARCH_OPTION', { type });
                                setBackOfficeSearchOption(prev => ({
                                    ...prev,
                                    type,
                                }));
                            }, setKeyword: (keyword) => {
                                if (keyword === undefined) {
                                    keyword = '';
                                }
                                APP.eventManager.publish('UPDATE_SEARCH_OPTION', {
                                    keyword,
                                });
                                setBackOfficeSearchOption(prev => ({
                                    ...prev,
                                    keyword,
                                }));
                            } }));
                }
            case 'statistics':
                if (menuDetail === 'userStatistics') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(statistics_1.StatisticsListTitle, { searchOption: searchOption, setSearchOption: handlerUpdateSearch, userType: userType, setUserType: setUserType }));
                    }
                }
                else if (menuDetail === 'concurrentStatistics') {
                    switch (showDepth) {
                        case 'list':
                            return (react_1.default.createElement(ConcurrentStatisticsTitle_1.ConcurrentStatisticsTitle, { refreshRate: refreshRate, setRefreshRate: setRefreshRate, refresh: refresh }));
                    }
                }
            default:
                return null;
        }
    }, [menu, menuDetail, showDepth, searchOption, setUserType, userType, backOfficeSearchOption, refresh, refreshRate]);
    const oneDepthMenu = (0, react_1.useMemo)(() => {
        switch (menu) {
            case 'serviceManagment':
                if (menuDetail === 'company')
                    return '회사 목록';
                if (menuDetail === 'user')
                    return '관리자 목록';
                if (menuDetail === 'version')
                    return '버전 관리';
                break;
            case 'classManagement':
                if (menuDetail === 'classManagement')
                    return '클래스 관리';
                if (menuDetail === 'banner')
                    return '배너 관리';
                break;
            case 'academyManagement':
                if (menuDetail === 'academyManagement')
                    return '학원 관리';
                if (menuDetail === 'academyClassManagement')
                    return '클래스 관리';
                break;
            case 'academyStatistics':
                if (menuDetail === 'academyStatistics')
                    return '학원 통계';
                if (menuDetail === 'academyClassStatistics')
                    return '클래스 통계';
                break;
            case 'backOffice':
                if (menuDetail === 'assignment')
                    return '과제 관리 목록';
                if (menuDetail === 'test')
                    return '테스트 관리 목록';
            case 'statistics':
                if (menuDetail === 'userStatistics')
                    return '사용자 통계';
                if (menuDetail === 'concurrentStatistics')
                    return '접속 통계';
            default:
                return null;
        }
    }, [menu, menuDetail]);
    const twoDepthMenu = (0, react_1.useMemo)(() => {
        if (showDepth === 'detail')
            return '상세 페이지';
        if (showDepth === 'regist')
            return '등록';
        if (showDepth === 'modify')
            return '수정';
        return '';
    }, [showDepth]);
    const backOfficeStyle = ['assignment', 'test'].includes(menuDetail) &&
        ['regist', 'modify'].includes(showDepth);
    return (react_1.default.createElement("div", { className: `admin-main`, style: backOfficeStyle ? { overflow: 'hidden' } : {} },
        react_1.default.createElement(AdminTitle_1.AdminTitle, { oneDepthMenu: oneDepthMenu, twoDepthMenu: twoDepthMenu, handlerPreviousMenu: handlerPreviousMenu }, renderTitleProps),
        react_1.default.createElement("div", { className: "admin-main-content", style: backOfficeStyle ? { height: 'unset', overflow: 'auto' } : {} }, renderMainContent)));
});
